import { Component, OnInit } from '@angular/core';
import { Tenant } from '../../../shared/models/tenant';
import { GridBaseComponent } from 'src/app/shared/components/grid-base.component';
import { OktaAuthService } from 'src/app/core/services/http/okta-auth.service';
import { TenantContextService } from 'src/app/shared/tenant-context/tenant-context.service';
import { ActivatedRoute, Router } from '@angular/router';

interface TenantListItem extends Tenant {
    locationDescription: string;
}
@Component({
    selector: 'cdp-tenant-selection',
    templateUrl: './tenant-selection.component.html',
    styleUrls: ['./tenant-selection.component.scss'],
    standalone: false
})
export class TenantsSelectionComponent extends GridBaseComponent<TenantListItem> implements OnInit {
    constructor(
        private tenantContextService: TenantContextService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private oktaAuthService: OktaAuthService
    ) {
        super(oktaAuthService);
    }

    async ngOnInit() {
        const hasTenantContext = await this.tenantContextService.prepTenantContext();

        if (hasTenantContext) {
            this.onTenantSelected();
        }
    }

    onTenantSelected() {
        this.router.navigate(['..', this.tenantContextService.currentTenant?.tenantId], {
            relativeTo: this.activatedRoute
        });
    }
}
